import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_MESSAGE = "You don't have permission to access this page.";

@Injectable({
  providedIn: 'root',
})
export class AccessDeniedService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  private messageSubject = new BehaviorSubject<string>(DEFAULT_MESSAGE);

  readonly isOpen$ = this.isOpenSubject.asObservable();
  readonly message$ = this.messageSubject.asObservable();

  show(message: string = DEFAULT_MESSAGE): void {
    this.messageSubject.next(message);
    this.isOpenSubject.next(true);
  }

  close(): void {
    this.isOpenSubject.next(false);
  }
}
